const getInitialCharacterCount = ({ defaultValue, value = '' })=>{
    if (value && 'string' == typeof value) return value.length;
    if (defaultValue && 'string' == typeof defaultValue) return defaultValue.length;
    return 0;
};
export { getInitialCharacterCount };
